const DELIVERY_FREQUENCY_UNIT = [
    { value: 0, text: 'Days' },
    { value: 1, text: 'Weeks' },
    { value: 2, text: 'Months' }
  ];

type DELIVERY_FREQUENCY_UNIT = typeof DELIVERY_FREQUENCY_UNIT;

export default DELIVERY_FREQUENCY_UNIT;